import { Box, CircularProgress } from "@mui/material";

export const LargeSpinner = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1,
      }}
    >
      <CircularProgress />
    </Box>
  );
};
